module.exports = __webpack_public_path__ + "static/media/award-modal-bg@2x.405d2116.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_230/imgs/award-modal-bg@2x.png
// module id = 1771
// module chunks = 0